module.exports = __webpack_public_path__ + "static/media/image-loader2.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/image-loader2.gif
// module id = 178
// module chunks = 1